import { TextDiv, TextSpan } from "../common/Text"
import quizSections from "./quizSections"

interface Props {
  sectionIdx: number
}

const SectionDescrioption = ({ sectionIdx }: Props) => {
  return (
    <>
      <TextDiv
        fontSize={20}
        fontWeight="bold"
        $align="start"
        style={{ marginTop: 30, marginBottom: 15 }}
      >
        {`다음은 `}
        <TextSpan fontSize={24} fontWeight="bold" color="var(--custom-blue)">
          {quizSections[sectionIdx].sectionName}
        </TextSpan>
        {`에 관한 문항입니다.`}
      </TextDiv>
      <TextDiv
        fontSize={18}
        fontWeight="bold"
        $align="start"
        style={{ marginBottom: 15 }}
      >
        {`${quizSections[sectionIdx].responseGuide} `}
        <TextSpan
          fontSize={18}
          fontWeight="bold"
          color="var(--custom-light-red)"
        >
          {quizSections[sectionIdx].responseOptions[0]}
          <TextSpan
            fontSize={16}
            color="var(--custom-gray)"
          >{`(1점)`}</TextSpan>
          <TextSpan fontSize={18} fontWeight="bold">{`, `}</TextSpan>
        </TextSpan>
        <TextSpan
          fontSize={18}
          fontWeight="bold"
          color="var(--custom-salmon-pink)"
        >
          {quizSections[sectionIdx].responseOptions[1]}
          <TextSpan
            fontSize={16}
            color="var(--custom-gray)"
          >{`(2점)`}</TextSpan>
          <TextSpan fontSize={18} fontWeight="bold">{`, `}</TextSpan>
        </TextSpan>
        <TextSpan fontSize={18} fontWeight="bold" color="var(--custom-gray)">
          {quizSections[sectionIdx].responseOptions[2]}
          <TextSpan
            fontSize={16}
            color="var(--custom-gray)"
          >{`(3점)`}</TextSpan>
          <TextSpan fontSize={18} fontWeight="bold">{`, `}</TextSpan>
        </TextSpan>
        <TextSpan
          fontSize={18}
          fontWeight="bold"
          color="var(--custom-light-blue)"
        >
          {quizSections[sectionIdx].responseOptions[3]}
          <TextSpan
            fontSize={16}
            color="var(--custom-gray)"
          >{`(4점)`}</TextSpan>
          <TextSpan fontSize={18} fontWeight="bold">{`, `}</TextSpan>
        </TextSpan>
        <TextSpan fontSize={18} fontWeight="bold" color="var(--custom-blue)">
          {quizSections[sectionIdx].responseOptions[4]}
          <TextSpan
            fontSize={16}
            color="var(--custom-gray)"
          >{`(5점)`}</TextSpan>
        </TextSpan>
        로 응답해주세요.
      </TextDiv>
    </>
  )
}

export default SectionDescrioption
